import { useMutation } from '@tanstack/vue-query'

import { useEventStore } from '../../../common/eventStore'

import { resendVerificationEmail } from '../emailVerificationService'

export function useResendVerificationEmailMutation() {
  const eventStore = useEventStore()

  return useMutation({
    mutationFn: async () => {
      return resendVerificationEmail()
    },
    onSuccess: async () => {
      eventStore.addToast({
        severity: 'success',
        summary: 'Verification Email Sent',
        detail: 'A new verification email has been sent to your inbox.',
      })
    },
  })
}
